import { render, staticRenderFns } from "./codeTab.vue?vue&type=template&id=6f0eff12&scoped=true&"
import script from "./codeTab.vue?vue&type=script&lang=js&"
export * from "./codeTab.vue?vue&type=script&lang=js&"
import style0 from "./codeTab.vue?vue&type=style&index=0&id=6f0eff12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0eff12",
  null
  
)

export default component.exports